export default __webpack_public_path__ + "static/hospitalityhero-e0cd8e081f7b7c7bc6ac4c9be2614306.jpg";